import { FC, ReactNode } from "react";
import { ThemeObject } from "../../ThemeObjects";
import { StyledUniversalDiv } from "../Universal";
import { ContentBlockEvents } from "../ContentBlockEvents";
import {
    DesignLayerFormContentBlockProvider,
    FormContentBlockDefaultValuesObject,
    FormContentBlockProvider,
} from "./FormContentBlockProvider";
import styled from "styled-components";
import { DynamicValidationRule } from "@/models";
import { cn } from "@/util";

type StyledFormContentBlockProps = ContentBlockEvents & {
    theme: Partial<ThemeObject>;
    children?: ReactNode;
    contentBlockId: string;
    questionFormObject?: FormContentBlockDefaultValuesObject;
    onFormSubmit?: (
        formObject: FormContentBlockDefaultValuesObject,
    ) => Promise<void>;
    validationRules: DynamicValidationRule[];
    isSubmitting: boolean;
};

const StyledForm = styled(StyledUniversalDiv)`
    &:has(.drag-and-drop-container) {
        width: 100% !important;
        max-width: 100%;
    }
`;

export const StyledFormContentBlock: FC<StyledFormContentBlockProps> = ({
    theme,
    children,
    contentBlockId,
    questionFormObject,
    onFormSubmit,
    validationRules,
    onClick,
    onHover,
    isSubmitting,
    isInEditorContext,
    title,
}) => {
    // return <pre>{JSON.stringify({ theme, contentBlockId }, null, 2)}</pre>;
    if (!isInEditorContext) {
        // return <pre>{JSON.stringify({ theme, contentBlockId }, null, 2)}</pre>;
        return (
            <StyledForm
                width={theme.width || "auto"}
                {...theme}
                data-content-block-id={contentBlockId}
                onClick={"function" === typeof onClick ? onClick : (evt) => {}}
                onMouseMove={
                    "function" === typeof onHover ? onHover : (evt) => {}
                }
                className="data-[has-width=false]:min-w-[70%]"
                data-has-width={!!theme.width}
                as="div"
                backgroundColor={
                    theme.imported_design_id
                        ? "transparent"
                        : theme.backgroundColor
                }
                hasMaxWidth={!!theme.hasMaxWidth}
            >
                <FormContentBlockProvider
                    defaultValues={questionFormObject}
                    onSubmit={onFormSubmit}
                    validationRules={validationRules}
                    isSubmitting={isSubmitting}
                    contentBlockId={contentBlockId}
                    isImported={!!theme?.imported_design_id}
                >
                    {theme?.imported_design_id ? (
                        <div className={cn(theme?.tailwindClasses)}>
                            {children}
                        </div>
                    ) : (
                        children
                    )}
                </FormContentBlockProvider>
            </StyledForm>
        );
    }

    return (
        <StyledForm
            {...theme}
            width={theme.width || "auto"}
            className="min-w-[70%]"
            data-content-block-id={contentBlockId}
            data-content-block-type={title || "Form"}
            onClick={"function" === typeof onClick ? onClick : (evt) => {}}
            onMouseMove={"function" === typeof onHover ? onHover : (evt) => {}}
        >
            <DesignLayerFormContentBlockProvider
                contentBlockId={contentBlockId}
                defaultValues={questionFormObject}
                onSubmit={onFormSubmit}
                validationRules={validationRules}
                isSubmitting={isSubmitting}
            >
                {children}
            </DesignLayerFormContentBlockProvider>
        </StyledForm>
    );
};

export const defaultFormTheme: Partial<ThemeObject> = {
    pt: 5,
    pb: 5,
    pl: 5,
    pr: 5,
    mt: 0,
    mb: 0,
    ml: 0,
    mr: 0,
    backgroundColor: "#ffffff",
    width: "100%",
};
